import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const DesignANewQuest = props => (
  <div className="design-a-new-quest" onClick={props.addQuest}>
    <FormattedMessage
      id={'Quests.DesignANewQuest'}
      defaultMessage={'Design a New Quest'}
    />
    <div id="addQuestIconContainer">
      <span id="addQuestIcon">+</span>
    </div>
  </div>
)

DesignANewQuest.propTypes = {
  addQuest: PropTypes.func.isRequired
}

export default DesignANewQuest



// WEBPACK FOOTER //
// ./src/components/mini/DesignANewQuest.js